import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { ChecklistDirective } from 'ng2-checklist';
import { ModalModule } from 'ng2-bootstrap';


import { AppComponent } from './app.component';
import {
  KoHeaderComponent,
  KoFooterComponent,
  KoOAuthComponent,
  KoRegManageComponent,
  KoRegComponent,
  KoIntroComponent,
  KoHomeComponent,
  KoSpeakersComponent
} from './ko/ko.component';

import {
  EnHeaderComponent,
  EnFooterComponent,
  EnHomeComponent,
  EnIntroComponent,
  EnSpeakersComponent
} from './en/en.component';


const appRoutes: Routes = [
  {path: '', redirectTo: 'ko', pathMatch: 'full'},
  {path: 'ko/kakao-oauth', component: KoOAuthComponent, pathMatch: 'full'},
  {path: 'ko/registration/:kakao_id', component: KoRegManageComponent, pathMatch: 'full'},
  {path: 'ko/registration', component: KoRegComponent, pathMatch: 'full'},
  {path: 'ko/speakers', component: KoSpeakersComponent, pathMatch: 'full'},
  {path: 'ko/intro', component: KoIntroComponent, pathMatch: 'full'},
  {path: 'ko', component: KoHomeComponent, pathMatch: 'full'},
  {path: 'en/speakers', component: EnSpeakersComponent, pathMatch: 'full'},
  {path: 'en/intro', component: EnIntroComponent, pathMatch: 'full'},
  {path: 'en', component: EnHomeComponent, pathMatch: 'full'},
];

@NgModule({
  declarations: [
    AppComponent,
    KoHeaderComponent,
    KoFooterComponent,
    KoOAuthComponent,
    KoRegManageComponent,
    KoRegComponent,
    KoSpeakersComponent,
    KoIntroComponent,
    KoHomeComponent,
    EnHeaderComponent,
    EnFooterComponent,
    EnIntroComponent,
    EnHomeComponent,
    EnSpeakersComponent,
    ChecklistDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
    ModalModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts